/* eanae — 데이터 정본 (classic script → window.EANAE_DATA)
   Website Feedback #2 핸드오프 반영(2026-08-12) → 피드백 반영 2(fb2) 적용(2026-08-24).
   소비: 홈(eanae-home.js) · Shop(eanae-shop.js) · 제품상세(eanae-product.js) · 드로어 검색(eanae-common.js).

   구조 메모
   - 문자열은 전부 {pt, en} 객체. 번역 안 하는 값(제품 영문명·INCI·순수 성분명)만 평문 string.
     한글(ko)은 fb2에서 전면 삭제 — 클라이언트 요청 "웹사이트 전체에서 한글만 삭제".
   - 이미지는 파일명만 보관 → window.eanaeAsset(파일명)으로 버전쿼리(?v=) 포함 CDN URL 로 바꾼다.
     새 파일명을 여기 추가하면 layout/eanae.liquid 의 ea_img_list 에도 넣어야 캐시가 무효화된다(fb6).
   - 장바구니/결제 없음. 구매는 제품별 buyUrl(오상 브라질몰 lancamento-eanae 컬렉션 안의 제품 페이지) 외부 링크로만.
     fb8(2026-09-23 핸드오프 "Buy links" 표). 선세럼만 오상 제품 페이지가 없어 컬렉션 페이지(BUY_BASE)로 보낸다.
   - PDP 카피(tagline/does/key/usage/inci)는 클라이언트 PPTX 원문 — 임의 수정 금지. */
(function () {
  "use strict";

  var BUY_BASE = "https://osangcosmetic.com/collections/lancamento-eanae";
  var AI_APP = "https://ai-filter-production.up.railway.app/";

  /* 쿠션 10톤. 언더톤 표기는 셰이드 확대 전까지 보류(핸드오프 결정) → under 필드 없음.
     톤별 컷은 eanae-cushion-{코드}.jpg(2026-09-04부터 해당 톤 제형 드롭컷), 미선택 기본은 타워컷 eanae-cushion-6.jpg. */
  var SHADES = [
    { c: "#F6E7DB", n: "110 Porcelain" },
    { c: "#F2DEC9", n: "130 Ivory" },
    { c: "#EDD3B6", n: "150 Vanilla" },
    { c: "#E2C1A0", n: "210 Natural" },
    { c: "#D8B18C", n: "230 Beige" },
    { c: "#C89F77", n: "250 Honey" },
    { c: "#B08260", n: "330 Caramel" },
    { c: "#93664A", n: "430 Mocha" },
    { c: "#755038", n: "530 Cocoa" },
    { c: "#573B28", n: "630 Espresso" },
  ];

  var PRODUCTS = [
    {
      id: "foam",
      group: "skincare",
      name: "Pore Control Cleansing Foam",
      brand: "eanae · 200 ml",
      img: "eanae-prod-foam.jpg",
      buyUrl: BUY_BASE + "/products/espuma-de-limpeza-facial-eanae-pore-control-cleansing-foam",
      cat: {
        pt: "Skincare · Limpeza",
        en: "Skincare · Cleanser",
      },
      subtitle: {
        pt: "Espuma de limpeza facial",
        en: "Low-pH cleansing foam",
      },
      sub: {
        pt: "Espuma de limpeza · pH baixo",
        en: "Low-pH cleansing foam",
      },
      note: {
        pt: "Limpa fundo os poros sem levar a hidratação essencial.",
        en: "Removes excess sebum and impurities without stripping essential moisture.",
      },
      kw: "pdrn snail low ph poro cleanser limpeza",
      step: {
        pt: "PASSO 1 · Limpeza & Equilíbrio",
        en: "STEP 1 · Cleanse & Balance",
      },
      flow: {
        pt: ["Limpeza profunda", "Proteção da hidratação", "Toque confortável"],
        en: ["Deep Cleansing", "Moisture Protection", "Comfortable Finish"],
      },
      tagline: {
        pt: "Um cleanser de pH baixo que remove o excesso de sebo e as impurezas dos poros sem levar embora a hidratação essencial.",
        en: "A low-pH pore cleanser that removes excess sebum and impurities without stripping away essential moisture.",
      },
      does: [
        {
          pt: "Limpa os poros em profundidade e remove o excesso de sebo.",
          en: "Deep cleans pores and removes excess sebum.",
        },
        {
          pt: "Ajuda a manter o equilíbrio natural de água e óleo da pele.",
          en: "Helps maintain skin’s natural oil-moisture balance.",
        },
        {
          pt: "Deixa a pele fresca, macia e confortável — nunca repuxada.",
          en: "Leaves skin feeling fresh, soft, and comfortable—never tight.",
        },
      ],
      key: [
        {
          t: {
            pt: "PDRN + Extrato de caramujo",
            en: "PDRN + Snail Extract",
          },
          d: {
            pt: "Condicionam e confortam a pele durante a limpeza.",
            en: "Condition and comfort skin during cleansing.",
          },
        },
        {
          t: {
            pt: "Ácido hialurônico de 8 tipos",
            en: "8-Type Hyaluronic Acid",
          },
          d: {
            pt: "Ajuda a repor e a reter a hidratação.",
            en: "Helps replenish and retain moisture.",
          },
        },
        {
          t: "Niacinamide",
          d: {
            pt: "Ajuda a equilibrar o excesso de oleosidade e o ressecamento.",
            en: "Helps balance excess oil and dryness.",
          },
        },
        {
          t: "Allantoin",
          d: {
            pt: "Ajuda a acalmar e a suavizar a pele.",
            en: "Helps soothe and soften skin.",
          },
        },
        {
          t: {
            pt: "Fórmula de pH baixo",
            en: "Low-pH Formula",
          },
          d: {
            pt: "Ajuda a preservar o ambiente naturalmente levemente ácido da pele.",
            en: "Helps preserve skin’s naturally mildly acidic environment.",
          },
        },
      ],
      usage: {
        pt: "Faça espuma com a quantidade adequada, massageie delicadamente o rosto e enxágue bem com água morna.",
        en: "Dispense an appropriate amount, work into a lather, gently massage over the face, and rinse thoroughly with lukewarm water.",
      },
      inci: "Water, Glycerin, Sodium Cocoyl Isethionate, Sorbeth-30 Tetraoleate, Decyl Glucoside, Sodium Methyl Cocoyl Taurate, 1,2-Hexanediol, Sodium Polyacrylate, Ethylhexylglycerin, Sodium Chloride, Allantoin, Niacinamide, Propanediol, Sodium Hyaluronate Crosspolymer, Hydrolyzed Glycosaminoglycans, Sodium Hyaluronate, Benzyl Glycol, Hydrolyzed Hyaluronic Acid, Hydroxypropyltrimonium Hyaluronate, Sodium DNA, Sodium Acetylated Hyaluronate, Hyaluronic Acid, Hydrolyzed Sodium Hyaluronate, Potassium Hyaluronate, Fragrance, Hexyl Cinnamal",
      hero: "eanae-foam-1.jpg",
      shots: ["eanae-foam-2.jpg", "eanae-foam-3.jpg", "eanae-foam-4.jpg", "eanae-foam-5.jpg"],
    },
    {
      id: "toner",
      group: "skincare",
      name: "Pink Glow Toner Mist",
      brand: "eanae · 120 ml",
      img: "eanae-prod-toner.jpg",
      buyUrl: BUY_BASE + "/products/tonico-facial-bifasico-em-bruma-eanae-pink-glow-toner-mist",
      cat: {
        pt: "Skincare · Toner",
        en: "Skincare · Toner",
      },
      subtitle: {
        pt: "Mist hidratante bifásico",
        en: "Bi-phase hydrating mist",
      },
      sub: {
        pt: "Mist hidratante bifásico",
        en: "Bi-phase hydrating mist",
      },
      note: {
        pt: "Repõe água na hora e sela o glow com esqualano.",
        en: "Instantly replenishes moisture and seals it in for a dewy glow.",
      },
      kw: "pdrn squalane toner mist hidrata",
      step: {
        pt: "PASSO 2 · Hidratação & Glow",
        en: "STEP 2 · Hydrate & Glow",
      },
      flow: {
        pt: [
          "Hidratação instantânea",
          "Equilíbrio de hidratação",
          "Selagem leve",
          "Glow rosado",
        ],
        en: [
          "Instant Hydration",
          "Moisture Balance",
          "Lightweight Sealing",
          "Dewy Pink Glow",
        ],
      },
      tagline: {
        pt: "Um mist hidratante bifásico que repõe a hidratação na hora e a sela para um glow fresco e orvalhado.",
        en: "A bi-phase hydrating mist that instantly replenishes moisture and seals it in for a fresh, dewy glow.",
      },
      does: [
        {
          pt: "Refresca e repõe a hidratação instantaneamente.",
          en: "Instantly refreshes and replenishes moisture.",
        },
        {
          pt: "Ajuda a manter a hidratação ao longo do dia.",
          en: "Helps maintain hydration throughout the day.",
        },
        {
          pt: "Sela a hidratação com um acabamento leve e não pegajoso.",
          en: "Seals in moisture with a lightweight, non-sticky finish.",
        },
        {
          pt: "Deixa a pele naturalmente orvalhada e radiante.",
          en: "Leaves skin naturally dewy and radiant.",
        },
      ],
      key: [
        {
          t: "PDRN",
          d: {
            pt: "Ajuda a condicionar a pele estressada pelo ressecamento e pela exposição ao ambiente.",
            en: "Helps condition skin stressed by dryness and environmental exposure.",
          },
        },
        {
          t: "Glyceryl Glucoside",
          d: {
            pt: "Apoia o equilíbrio e a retenção de hidratação.",
            en: "Supports moisture balance and retention.",
          },
        },
        {
          t: {
            pt: "Ácido hialurônico de 5 tipos",
            en: "5-Type Hyaluronic Acid",
          },
          d: {
            pt: "Entrega hidratação em múltiplos níveis.",
            en: "Delivers multi-level hydration.",
          },
        },
        {
          t: "Magnesium",
          d: {
            pt: "Oferece um condicionamento mineral refrescante.",
            en: "Provides refreshing mineral conditioning.",
          },
        },
        {
          t: "Squalane",
          d: {
            pt: "Cria uma camada leve que sela a hidratação.",
            en: "Creates a lightweight moisture-sealing layer.",
          },
        },
        {
          t: "Dexpanthenol",
          d: {
            pt: "Ajuda a acalmar e a apoiar a barreira da pele.",
            en: "Helps soothe and support the skin barrier.",
          },
        },
        {
          t: "Niacinamide",
          d: {
            pt: "Ajuda a equilibrar a pele e a melhorar o aspecto do tom desigual.",
            en: "Helps balance skin and improve the appearance of uneven tone.",
          },
        },
      ],
      usage: {
        pt: "Agite antes de usar. Com os olhos fechados, borrife a cerca de 20 cm do rosto e dê leves batidinhas para absorver. Reaplique sempre que sentir a pele seca.",
        en: "Shake well before use. With eyes closed, mist over the face from about 20 cm away and pat gently to absorb. Reapply whenever skin feels dry.",
      },
      inci: "Water, Squalane, Niacinamide, Glycerin, 1,2-Hexanediol, Sodium Chloride, Ethylhexylglycerin, Citric Acid, Sodium Citrate, Caprylic/Capric Triglyceride, Glyceryl Glucoside, Panthenol, Lithospermum Erythrorhizon Root Extract, Propanediol, Sodium Hyaluronate Crosspolymer, Hydrolyzed Glycosaminoglycans, Sodium Hyaluronate, Magnesium Chloride, Sodium DNA, Benzyl Glycol, Hydrolyzed Hyaluronic Acid, Hyaluronic Acid, Fragrance",
      shots: ["eanae-toner-2.jpg", "eanae-toner-3.jpg", "eanae-toner-4.jpg", "eanae-toner-5.jpg"],
    },
    {
      id: "serum",
      group: "skincare",
      name: "Glow Pearl Serum",
      brand: "eanae · 30 ml",
      img: "eanae-prod-serum.jpg",
      buyUrl: BUY_BASE + "/products/serum-facial-eanae-glow-pearl-serum",
      cat: {
        pt: "Skincare · Sérum",
        en: "Skincare · Serum",
      },
      subtitle: {
        pt: "Sérum reparador intensivo",
        en: "Intensive repair serum",
      },
      sub: {
        pt: "Sérum reparador intensivo",
        en: "Intensive repair serum",
      },
      note: {
        pt: "Acalma a pele estressada e repõe água e lipídios da barreira.",
        en: "Soothes stressed skin while replenishing hydration and barrier lipids.",
      },
      kw: "pdrn cica niacinamide serum",
      step: {
        pt: "PASSO 3 · Acalmar & Reparar",
        en: "STEP 3 · Soothe & Repair",
      },
      flow: {
        pt: [
          "Alívio rápido",
          "Hidratação profunda",
          "Reposição da barreira",
          "Glow saudável",
        ],
        en: [
          "Rapid Soothing",
          "Deep Hydration",
          "Barrier Replenishment",
          "Healthy Glow",
        ],
      },
      tagline: {
        pt: "Um sérum reparador intensivo que acalma a pele estressada enquanto repõe hidratação e os lipídios essenciais da barreira.",
        en: "An intensive repair serum that soothes stressed skin while replenishing hydration and essential barrier lipids.",
      },
      does: [
        {
          pt: "Ajuda a acalmar a pele estressada pelo sol, pelo calor e pelo ressecamento.",
          en: "Helps calm skin stressed by sun, heat, and dryness.",
        },
        {
          pt: "Entrega hidratação duradoura sem peso.",
          en: "Delivers lasting hydration without heaviness.",
        },
        {
          pt: "Apoia uma barreira de hidratação mais forte e saudável.",
          en: "Supports a stronger, healthier moisture barrier.",
        },
        {
          pt: "Deixa a pele mais lisa, mais calma e naturalmente radiante.",
          en: "Leaves skin smoother, calmer, and naturally radiant.",
        },
      ],
      key: [
        {
          t: "PDRN",
          d: {
            pt: "Apoia a recuperação de uma pele com aparência saudável.",
            en: "Supports healthy-looking skin recovery.",
          },
        },
        {
          t: "Glyceryl Glucoside",
          d: {
            pt: "Apoia os canais de hidratação da pele.",
            en: "Supports the skin’s moisture pathways.",
          },
        },
        {
          t: { pt: "Complexo CICA", en: "CICA Complex" },
          d: {
            pt: "Ajuda a acalmar visivelmente a vermelhidão e a sensibilidade.",
            en: "Helps visibly soothe redness and sensitivity.",
          },
        },
        {
          t: "Dexpanthenol",
          d: {
            pt: "Ajuda a confortar a pele e a apoiar a recuperação da barreira.",
            en: "Helps comfort skin and support barrier recovery.",
          },
        },
        {
          t: {
            pt: "Ácido hialurônico de 5 tipos + Beta-glucana",
            en: "5-Type Hyaluronic Acid + Beta-Glucan",
          },
          d: {
            pt: "Repõem e retêm a hidratação.",
            en: "Replenish and retain moisture.",
          },
        },
        {
          t: {
            pt: "Complexo de 5 ceramidas",
            en: "5-Ceramide Complex",
          },
          d: {
            pt: "Repõe os lipídios essenciais da barreira.",
            en: "Replenishes essential barrier lipids.",
          },
        },
        {
          t: "Niacinamide",
          d: {
            pt: "Ajuda a equilibrar a pele e a melhorar o tom que parece desigual.",
            en: "Helps balance skin and improve uneven-looking tone.",
          },
        },
        {
          t: "Allantoin",
          d: {
            pt: "Ajuda a acalmar e a suavizar a pele áspera.",
            en: "Helps soothe and smooth rough skin.",
          },
        },
      ],
      usage: {
        pt: "Aplique a quantidade adequada em todo o rosto e dê leves batidinhas para absorver.",
        en: "Apply an appropriate amount evenly over the face and pat gently to absorb.",
      },
      inci: "Water, Glycerin, Butylene Glycol, Propanediol, Niacinamide, Glyceryl Glucoside, 1,2-Hexanediol, Caprylic/Capric Triglyceride, Ammonium Polyacryloyldimethyl Taurate, Betaine, Isononyl Isononanoate, Panthenol, Ethylhexylglycerin, Polyglyceryl-10 Laurate, Allantoin, Disodium EDTA, Xanthan Gum, Sodium Hyaluronate Crosspolymer, Asiaticoside, Madecassic Acid, Hydrolyzed Glycosaminoglycans, Carbomer, Arginine, Asiatic Acid, Beta-Glucan, Sodium Hyaluronate, Sodium DNA, Benzyl Glycol, Hydrogenated Lecithin, Ceramide NP, Hydrolyzed Hyaluronic Acid, Tocopheryl Acetate, Ceramide NS, Ceramide AS, Ceramide EOP, Ceramide AP, Hyaluronic Acid, Fragrance",
      shots: ["eanae-serum-2.jpg", "eanae-serum-3.jpg", "eanae-serum-4.jpg", "eanae-serum-5.jpg"],
    },
    {
      id: "cream",
      group: "skincare",
      name: "Air Barrier Cream",
      brand: "eanae · 50 g",
      img: "eanae-prod-cream.jpg",
      buyUrl: BUY_BASE + "/products/creme-facial-eanae-air-barrier-cream",
      cat: {
        pt: "Skincare · Creme",
        en: "Skincare · Cream",
      },
      subtitle: {
        pt: "Creme-barreira leve",
        en: "Air-light barrier cream",
      },
      sub: {
        pt: "Creme-barreira leve",
        en: "Air-light barrier cream",
      },
      note: {
        pt: "Sela a hidratação e cuida da firmeza, sem peso.",
        en: "Locks in moisture while delivering firming and anti-aging care.",
      },
      kw: "pdrn ceramide nmn nad barrier cream",
      step: {
        pt: "PASSO 4 · Selar & Fortalecer",
        en: "STEP 4 · Seal & Strengthen",
      },
      flow: {
        pt: [
          "Infusão de hidratação",
          "Reposição lipídica",
          "Selagem da barreira",
          "Cuidado de firmeza",
        ],
        en: [
          "Moisture Infusion",
          "Lipid Replenishment",
          "Barrier Sealing",
          "Firming Care",
        ],
      },
      tagline: {
        pt: "Um creme-barreira leve como ar que retém a hidratação enquanto entrega cuidado avançado de firmeza e antissinais.",
        en: "An air-light barrier cream that locks in moisture while delivering advanced firming and anti-aging care.",
      },
      does: [
        {
          pt: "Repõe os lipídios essenciais para apoiar a barreira da pele.",
          en: "Replenishes essential lipids to support the skin barrier.",
        },
        {
          pt: "Retém a hidratação sem sensação pesada ou pegajosa.",
          en: "Locks in hydration without feeling heavy or sticky.",
        },
        {
          pt: "Ajuda a melhorar a aparência da firmeza e das linhas finas.",
          en: "Helps improve the appearance of firmness and fine lines.",
        },
        {
          pt: "Deixa a pele macia, resistente e confortavelmente hidratada.",
          en: "Leaves skin soft, resilient, and comfortably moisturized.",
        },
      ],
      key: [
        {
          t: "PDRN",
          d: {
            pt: "Apoia uma pele resistente e com aparência saudável.",
            en: "Supports resilient, healthy-looking skin.",
          },
        },
        {
          t: {
            pt: "Complexo de 5 ceramidas + Esteróis vegetais + Ácidos graxos",
            en: "5-Ceramide Complex + Plant-Derived Sterols + Fatty Acids",
          },
          d: {
            pt: "Ajudam a repor a barreira lipídica da pele.",
            en: "Help replenish the skin’s lipid barrier.",
          },
        },
        {
          t: "NMN + NAD",
          d: {
            pt: "Ajudam a apoiar uma pele com aparência revitalizada.",
            en: "Help support revitalized-looking skin.",
          },
        },
        {
          t: "Dexpanthenol",
          d: {
            pt: "Ajuda a acalmar e a apoiar a recuperação da barreira.",
            en: "Helps soothe and support barrier recovery.",
          },
        },
        {
          t: {
            pt: "Complexo de peptídeos + Adenosina",
            en: "Peptide Complex + Adenosine",
          },
          d: {
            pt: "Ajudam a melhorar o aspecto da firmeza e das linhas finas.",
            en: "Help improve the look of firmness and fine lines.",
          },
        },
        {
          t: "Squalane",
          d: {
            pt: "Ajuda a selar a hidratação com uma camada protetora leve.",
            en: "Helps seal in moisture with a lightweight protective layer.",
          },
        },
        {
          t: "Niacinamide",
          d: {
            pt: "Ajuda a equilibrar a pele e a melhorar o tom que parece desigual.",
            en: "Helps balance skin and improve uneven-looking tone.",
          },
        },
        {
          t: "Glyceryl Glucoside",
          d: {
            pt: "Apoia o equilíbrio e a retenção de hidratação.",
            en: "Supports moisture balance and retention.",
          },
        },
        {
          t: {
            pt: "Ácido hialurônico de 6 tipos",
            en: "6-Type Hyaluronic Acid",
          },
          d: {
            pt: "Proporciona hidratação em múltiplos níveis.",
            en: "Provides multi-level hydration.",
          },
        },
      ],
      usage: {
        pt: "Aplique a quantidade adequada no rosto e no pescoço e dê leves batidinhas para absorver.",
        en: "Apply an appropriate amount over the face and neck, then pat gently to absorb.",
      },
      inci: "Water, Caprylic/Capric Triglyceride, Propanediol, Polyglyceryl-3 Methylglucose Distearate, Glycerin, Butylene Glycol, Glycereth-26, Cetearyl Alcohol, Niacinamide, Squalane, Dimethicone, 1,2-Hexanediol, Glyceryl Glucoside, Panthenol, Hydrogenated Lecithin, Ethylhexylglycerin, Hydrolyzed Glycosaminoglycans, Allantoin, Arginine, Sodium Hyaluronate, Trehalose, Phytosterols, Disodium EDTA, Adenosine, Xanthan Gum, Sodium Hyaluronate Crosspolymer, Ceramide NP, Sodium DNA, Nicotinamide Adenine Dinucleotide, Nicotinamide Mononucleotide, Benzyl Glycol, Tocopheryl Acetate, Hydrolyzed Hyaluronic Acid, Ceramide NS, Ceramide AS, Ceramide EOP, Ceramide AP, Hyaluronic Acid, Copper Tripeptide-1, Palmitoyl Pentapeptide-4, Tripeptide-1, Palmitoyl Tripeptide-1, Hexapeptide-9, Hexapeptide-11, Fragrance",
      hero: "eanae-cream-1.jpg",
      shots: ["eanae-cream-2.jpg", "eanae-cream-3.jpg", "eanae-cream-4.jpg", "eanae-cream-5.jpg"],
    },
    {
      id: "sun",
      group: "skincare",
      name: "Daily Clear Sun Serum",
      brand: "eanae · 50 ml",
      img: "eanae-prod-sun.jpg",
      buyUrl: BUY_BASE,
      spf: "SPF50+ / PA++++",
      cat: {
        pt: "Skincare · Protetor solar",
        en: "Skincare · Sun care",
      },
      subtitle: {
        pt: "Protetor solar em sérum",
        en: "Daily sun serum",
      },
      sub: {
        pt: "Protetor solar SPF50+ / PA++++",
        en: "Sun serum SPF50+ / PA++++",
      },
      note: {
        pt: "Alta proteção UV com sensação leve de sérum.",
        en: "High UV protection paired with skin-conditioning care.",
      },
      kw: "spf50 pa sun protetor solar pdrn",
      step: {
        pt: "PASSO 5 · Proteção Solar",
        en: "STEP 5 · Protect & Defend",
      },
      flow: {
        pt: [
          "Alta proteção UV",
          "Defesa da hidratação",
          "Cuidado de vitalidade",
          "Apoio antifotoenvelhecimento",
        ],
        en: [
          "High UV Protection",
          "Moisture Defense",
          "Vitality Care",
          "Anti-Photoaging Support",
        ],
      },
      tagline: {
        pt: "Um sérum solar diário e leve que une alta proteção UV a um cuidado que condiciona a pele.",
        en: "A lightweight daily sun serum that pairs high UV protection with skin-conditioning care.",
      },
      does: [
        {
          pt: "Oferece alta proteção contra UVA e UVB.",
          en: "Provides high UVA and UVB protection.",
        },
        {
          pt: "Ajuda a manter a pele confortável durante a exposição solar diária.",
          en: "Helps keep skin comfortable during daily sun exposure.",
        },
        {
          pt: "Apoia a hidratação e a condição da pele ao longo do dia.",
          en: "Supports hydration and skin condition throughout the day.",
        },
        {
          pt: "Fica leve e fresco, sem sensação pesada ou pegajosa.",
          en: "Wears light and fresh without a heavy, sticky feel.",
        },
      ],
      key: [
        {
          t: {
            pt: "Sistema avançado de filtros UV",
            en: "Advanced UV Filter System",
          },
          d: {
            pt: "Proporciona proteção eficaz contra UVA e UVB.",
            en: "Provides effective UVA and UVB protection.",
          },
        },
        {
          t: "PDRN",
          d: {
            pt: "Ajuda a condicionar a pele exposta ao estresse ambiental do dia a dia.",
            en: "Helps condition skin exposed to daily environmental stress.",
          },
        },
        {
          t: "NMN + NAD",
          d: {
            pt: "Ajudam a apoiar uma pele com aparência revitalizada.",
            en: "Help support revitalized-looking skin.",
          },
        },
        {
          t: {
            pt: "Complexo multipeptídico",
            en: "Multi-Peptide Complex",
          },
          d: {
            pt: "Ajuda a apoiar o aspecto de firmeza da pele.",
            en: "Helps support the look of skin firmness.",
          },
        },
      ],
      usage: {
        pt: "Espalhe uniformemente no rosto e no pescoço antes da exposição ao sol. Reaplique após suar, entrar na água ou sempre que necessário.",
        en: "Apply evenly to the face and neck before sun exposure. Reapply after sweating, swimming, or whenever needed.",
      },
      inci: "Water, Neopentyl Glycol Diheptanoate, Diisopropyl Sebacate, C12-15 Alkyl Benzoate, 2,3-Butanediol, Terephthalylidene Dicamphor Sulfonic Acid, Niacinamide, Diethylamino Hydroxybenzoyl Hexyl Benzoate, Bis-Ethylhexyloxyphenol Methoxyphenyl Triazine, Ethylhexyl Triazone, Caprylic/Capric Triglyceride, Tromethamine, 1,2-Hexanediol, Polyacrylate Crosspolymer-6, Hydrogenated Poly(C6-20 Olefin), HDI/Trimethylol Hexyllactone Crosspolymer, Fragrance, Melia Azadirachta Extract, Adenosine, Ethylhexylglycerin, Moringa Oleifera Seed Oil, Butylene Glycol, Sodium DNA, Tocopherol, Glycerin, Nicotinamide Adenine Dinucleotide, Nicotinamide Mononucleotide, Hydrogenated Lecithin, Acetyl Hexapeptide-8, Copper Tripeptide-1, Tripeptide-1, Palmitoyl Tripeptide-5, Palmitoyl Pentapeptide-4, Hexapeptide-9, sh-Oligopeptide-1, Hexapeptide-12, Palmitoyl Tripeptide-38, Pentapeptide-4",
      hero: "eanae-sun-1.jpg",
      shots: ["eanae-sun-2.jpg", "eanae-sun-3.jpg", "eanae-sun-4.jpg", "eanae-sun-5.jpg"],
    },
    {
      id: "cushion",
      group: "makeup",
      name: "Perfect Pore Cover Cushion",
      brand: "eanae · 15 g · Base / Foundation",
      img: "eanae-prod-cushion.jpg",
      buyUrl: BUY_BASE + "/products/base-cushion-eanae-perfect-pore-cover-spf35",
      spf: "SPF35 / PA+++",
      isCushion: true,
      cat: {
        pt: "Makeup · Base cushion",
        en: "Makeup · Base cushion",
      },
      subtitle: {
        pt: "Base cushion com skincare",
        en: "Skincare-infused base cushion",
      },
      sub: {
        pt: "Base cushion SPF35 / PA+++ · 10 tons",
        en: "Base cushion SPF35 / PA+++ · 10 shades",
      },
      note: {
        pt: "Disfarça poros, uniformiza o tom e cuida da pele o dia todo.",
        en: "Blurs pores, evens skin tone and delivers smooth coverage with daily UV protection.",
      },
      kw: "cushion base foundation spf35",
      step: {
        pt: "PASSO 6 · Maquiagem & Cuidado",
        en: "STEP 6 · Perfect & Condition",
      },
      flow: {
        pt: [
          "Disfarce de poros",
          "Correção de tom",
          "Equilíbrio de hidratação",
          "Acabamento liso",
        ],
        en: [
          "Pore Blurring",
          "Tone Correction",
          "Moisture Balance",
          "Smooth Skin Finish",
        ],
      },
      tagline: {
        pt: "Um cushion com skincare na fórmula que disfarça os poros, uniformiza o tom e entrega cobertura lisa com proteção solar diária.",
        en: "A skincare-infused cushion that blurs pores, evens skin tone, and delivers smooth coverage with daily UV protection.",
      },
      does: [
        {
          pt: "Disfarça visivelmente os poros e a textura que parece desigual.",
          en: "Visibly blurs pores and uneven-looking texture.",
        },
        {
          pt: "Cria uma pele de aspecto liso e uniforme.",
          en: "Creates a smooth, even-looking complexion.",
        },
        {
          pt: "Ajuda a manter um equilíbrio confortável de água e óleo durante o uso.",
          en: "Helps maintain comfortable oil-moisture balance during wear.",
        },
        {
          pt: "Adiciona proteção solar diária com SPF35/PA+++.",
          en: "Adds everyday UV protection with SPF35/PA+++.",
        },
      ],
      key: [
        {
          t: "PDRN",
          d: {
            pt: "Ajuda a condicionar a pele durante todo o tempo de maquiagem.",
            en: "Helps condition skin throughout makeup wear.",
          },
        },
        {
          t: "Niacinamide",
          d: {
            pt: "Ajuda a equilibrar a pele e a manter um tom de aspecto uniforme.",
            en: "Helps balance skin and maintain an even-looking tone.",
          },
        },
        {
          t: "Adenosine",
          d: {
            pt: "Ajuda a melhorar a aparência das linhas finas.",
            en: "Helps improve the appearance of fine lines.",
          },
        },
        {
          t: {
            pt: "Complexo multipeptídico",
            en: "Multi-Peptide Complex",
          },
          d: {
            pt: "Ajuda a apoiar a firmeza da pele.",
            en: "Helps support skin firmness.",
          },
        },
        {
          t: "NMN + NAD",
          d: {
            pt: "Ajudam a apoiar uma pele de aspecto fresco e revitalizado.",
            en: "Help support fresh, revitalized-looking skin.",
          },
        },
      ],
      usage: {
        pt: "Pegue uma pequena quantidade com o aplicador e dê batidinhas leves, do centro do rosto para fora. Reaplique em camadas finas onde precisar de mais cobertura.",
        en: "Pick up a small amount with the applicator and pat lightly from the center of the face outward. Build thin layers where more coverage is needed.",
      },
      inci: "Water, Squalane, Niacinamide, Glycerin, 1,2-Hexanediol, Sodium Chloride, Ethylhexylglycerin, Citric Acid, Sodium Citrate, Caprylic/Capric Triglyceride, Glyceryl Glucoside, Panthenol, Lithospermum Erythrorhizon Root Extract, Propanediol, Sodium Hyaluronate Crosspolymer, Hydrolyzed Glycosaminoglycans, Sodium Hyaluronate, Magnesium Chloride, Sodium DNA, Benzyl Glycol, Hydrolyzed Hyaluronic Acid, Hyaluronic Acid, Fragrance",
      hero: "eanae-cushion-1.jpg",
      shots: ["eanae-cushion-2.jpg", "eanae-cushion-3.jpg", "eanae-cushion-4.jpg", "eanae-cushion-5.jpg"],
    },
    {
      id: "shampoo",
      group: "haircare",
      name: "Silky Serum Shampoo",
      brand: "eanae · 300 ml",
      img: "eanae-prod-shampoo.jpg",
      buyUrl: BUY_BASE + "/products/shampoo-eanae-silky-serum",
      cat: {
        pt: "Haircare · Shampoo",
        en: "Haircare · Shampoo",
      },
      subtitle: {
        pt: "Shampoo em sérum",
        en: "Serum shampoo",
      },
      sub: {
        pt: "Shampoo em sérum · couro cabeludo",
        en: "Serum shampoo · scalp care",
      },
      note: {
        pt: "Refresca o couro cabeludo e deixa os fios macios e sedosos.",
        en: "Refreshes the scalp while smoothing and conditioning damaged hair.",
      },
      kw: "shampoo scalp biotin caffeine",
      step: {
        pt: "PASSO 7 · Cabelo & Couro Cabeludo",
        en: "STEP 7 · Refresh & Repair",
      },
      flow: {
        pt: [
          "Limpeza do couro cabeludo",
          "Equilíbrio água-óleo",
          "Cuidado das raízes",
          "Cobertura proteica",
          "Acabamento sedoso",
        ],
        en: [
          "Scalp Cleansing",
          "Oil-Water Balance",
          "Root Conditioning",
          "Protein Coating",
          "Silky Finish",
        ],
      },
      tagline: {
        pt: "Um shampoo em sérum que equilibra e refresca o couro cabeludo enquanto suaviza e condiciona os fios danificados.",
        en: "A balancing serum shampoo that refreshes the scalp while smoothing and conditioning damaged hair.",
      },
      does: [
        {
          pt: "Limpa o excesso de oleosidade e as impurezas para um couro cabeludo fresco.",
          en: "Cleanses excess oil and impurities for a fresh scalp.",
        },
        {
          pt: "Ajuda a manter um equilíbrio confortável de água e óleo no couro cabeludo.",
          en: "Helps maintain comfortable scalp oil-moisture balance.",
        },
        {
          pt: "Condiciona os fios estressados por raios UV, calor e tratamentos químicos.",
          en: "Conditions hair stressed by UV, heat, and chemical treatments.",
        },
        {
          pt: "Deixa os fios danificados macios, lisos e sedosos, sem peso.",
          en: "Leaves damaged hair feeling soft, smooth, and silky without heaviness.",
        },
      ],
      key: [
        {
          t: "PDRN",
          d: {
            pt: "Ajuda a condicionar e a manter um ambiente saudável no couro cabeludo.",
            en: "Helps condition and maintain a healthy scalp environment.",
          },
        },
        {
          t: "Caffeine",
          d: {
            pt: "Ajuda a refrescar e a revitalizar o couro cabeludo e as raízes.",
            en: "Helps refresh and revitalize the scalp and roots.",
          },
        },
        {
          t: "Biotin",
          d: {
            pt: "Condiciona os fios finos e de aparência frágil.",
            en: "Conditions fine, weak-looking hair.",
          },
        },
        {
          t: "Dexpanthenol",
          d: {
            pt: "Ajuda a acalmar o ressecamento e o desconforto do couro cabeludo.",
            en: "Helps soothe scalp dryness and discomfort.",
          },
        },
        {
          t: "Niacinamide",
          d: {
            pt: "Ajuda a equilibrar a oleosidade e a hidratação do couro cabeludo.",
            en: "Helps balance scalp oil and moisture.",
          },
        },
        {
          t: {
            pt: "7 proteínas de origem vegetal",
            en: "7 Plant-Based Proteins",
          },
          d: {
            pt: "Ajudam a alisar as cutículas danificadas para fios mais macios e fáceis de pentear.",
            en: "Help smooth damaged cuticles for softer, more manageable hair.",
          },
        },
      ],
      usage: {
        pt: "Molhe bem o couro cabeludo e os fios, faça espuma com a quantidade adequada, massageie suavemente e enxágue com água morna.",
        en: "Thoroughly wet the scalp and hair, work an appropriate amount into a lather, massage gently, and rinse with lukewarm water.",
      },
      inci: "Water, Sodium C14-16 Olefin Sulfonate, Glycerin, Fragrance, Lauryl Hydroxysultaine, Sodium Chloride, Coco-Betaine, Sodium Methyl Cocoyl Taurate, 1,2-Hexanediol, PCA Glyceryl Oleate, Polyquaternium-10, Ethylhexylglycerin, Hydroxypropyl Guar Hydroxypropyltrimonium Chloride, Polyquaternium-67, Propanediol, Polyglyceryl-10 Laurate, Citric Acid, Niacinamide, Polyquaternium-7, Panthenol, Sodium Acetate, Caffeine, Biotin, Sodium Benzoate, Sodium DNA, Hydrolyzed Rice Protein, Hydrolyzed Wheat Protein, Hydrolyzed Soy Protein, Hydrolyzed Pea Protein, Hydrolyzed Corn Protein, Hydrolyzed Hemp Seed Protein, Hydrolyzed Oat Protein, Benzyl Benzoate, Hydroxycitronellal, Linalool",
      hero: "eanae-shampoo-1.jpg",
      shots: ["eanae-shampoo-2.jpg", "eanae-shampoo-3.jpg", "eanae-shampoo-4.jpg", "eanae-shampoo-5.jpg"],
    },
  ];

  /* 홈 드로어 검색의 추천 키워드 칩 */
  var SUGGEST = [
    { pt: "PDRN", en: "PDRN", href: "/?view=shop" },
    {
      pt: "Base cushion",
      en: "Base cushion",
      href: "/?view=shop#makeup",
    },
    {
      pt: "Protetor solar",
      en: "Sunscreen",
      href: "/?view=produto&id=sun",
    },
    {
      pt: "Barreira",
      en: "Barrier cream",
      href: "/?view=produto&id=cream",
    },
    { pt: "Shampoo", en: "Shampoo", href: "/?view=shop#haircare" },
  ];

  /* Shop 탭 — id는 URL 해시와 동일 */
  var TABS = [
    {
      id: "all",
      label: { pt: "Ver tudo", en: "Shop All" },
      title: { pt: "Ver tudo", en: "Shop All" },
    },
    {
      id: "skincare",
      label: { pt: "Skincare", en: "Skincare" },
      title: { pt: "Skincare", en: "Shop Skincare" },
    },
    {
      id: "makeup",
      label: { pt: "Makeup", en: "Makeup" },
      title: { pt: "Makeup", en: "Shop Makeup" },
    },
    {
      id: "haircare",
      label: { pt: "Haircare", en: "Haircare" },
      title: { pt: "Haircare", en: "Shop Haircare" },
    },
  ];

  /* JS 렌더 화면(Shop·PDP)에서만 쓰는 문구. Liquid 섹션은 .i18n/data-ko/data-en으로 직접 처리. */
  var UI = {
    productsUnit: { pt: "Produtos", en: "Products" },
    productsUnitOne: { pt: "Produto", en: "Product" },
    sortBy: {
      pt: "Ordenar por: Destaques",
      en: "Sort By: Featured",
    },
    breadcrumb: { pt: "Produtos", en: "Products" },
    doesH: { pt: "O que faz", en: "What it does" },
    keyH: {
      pt: "Ingredientes-chave",
      en: "Key ingredients",
    },
    usageH: { pt: "Como usar", en: "How to use" },
    inciH: {
      pt: "Ingredientes (INCI)",
      en: "Ingredients (INCI)",
    },
    buyCta: {
      pt: "Comprar na loja oficial ↗",
      en: "Buy at the official store ↗",
    },
    buyNote: {
      pt: "A compra acontece na loja oficial Osang.",
      en: "Purchases are completed at the official Osang store.",
    },
    aiCta: {
      pt: "Provar meu tom com IA →",
      en: "Try my shade with AI →",
    },
    shadePrefix: { pt: "Tom: ", en: "Shade: " },
    /* 홈 쿠션 밴드의 미선택(타워컷) 상태 캡션 */
    shadePick: { pt: "Escolha um tom", en: "Choose a shade" },
    shadeNote: {
      pt: "* As cores na tela são aproximadas. Confira seu tom com a ferramenta de IA ou na loja.",
      en: "* On-screen colors are approximate. Confirm your shade with the AI tool or at the store.",
    },
    relatedH: {
      pt: "Continue a rotina",
      en: "Continue the routine",
    },
    notFound: {
      pt: "Produto não encontrado",
      en: "Product not found",
    },
    loading: { pt: "Carregando…", en: "Loading…" },
  };

  window.EANAE_DATA = {
    AI_APP: AI_APP,
    SHADES: SHADES,
    PRODUCTS: PRODUCTS,
    SUGGEST: SUGGEST,
    TABS: TABS,
    UI: UI,
  };
  try {
    window.dispatchEvent(new Event("eanae-data-ready"));
  } catch (e) {}
})();
